<!--
 * @Description:  员工关系
 * @Autor: yd
 * @Date: 2020-07-27 10:37:42
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-10-18 14:21:40
-->
<template>
  <mrc_ess_skeleton_loader :loading="$store.state.uuid ? skeletonloading : false">
    <v-card>
      <v-card-text>
        <v-row>
          <v-col cols="12"
                 sm="6">
            <mrc_ess_multiText :label="$t('key')"
                               noRequired
                               :error-messages="
                  $errors('list', 'key', requiredRule)
                  "
                               :isNational="judegNational('key')"
                               v-model="list.key"
                               :readonly="disabled">
            </mrc_ess_multiText>
          </v-col>
          <v-col cols="12"
                 sm="6">
            <mrc_ess_multiText :label="$t('value')"
                               noRequired
                               :error-messages="
                  $errors('list', 'value', requiredRule)
                  "
                               :isNational="judegNational('value')"
                               v-model="list.value"
                               :readonly="disabled">
            </mrc_ess_multiText>
          </v-col>
          <v-col cols="12">
            <mrc_ess_multiText :label="$t('label_describe')"
                               noRequired
                               :error-messages="
                  $errors('list', 'descrirption', requiredRule)
                  "
                               :isNational="judegNational('descrirption')"
                               v-model="list.descrirption"
                               :readonly="disabled">
            </mrc_ess_multiText>
          </v-col>
        </v-row>
      </v-card-text>
      <mrc_ess_submitBtn @success="success"
                         @cancel="cancel"
                         :loading="btnIsLoading"
                         v-if="!disabled">
      </mrc_ess_submitBtn>
    </v-card>
  </mrc_ess_skeleton_loader>
</template>

<script>
import {
  custom_param_config_list,
  add_custom_param_config
} from "@/service/api/customParamConfig.js"
import { getBusinessList } from '@/service/api/prompt.js'
import {
  required,
  maxLength,
  between,
  email,
  url,
} from 'vuelidate/lib/validators'
export default {
  components: {},
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      skeletonloading: true,
      dropDownList: [],
      list: {
        // correlation_status: 1
      },
      btnIsLoading: false,
      viewList: {},
    }
  },
  computed: {
  },
  async created () {

  },
  watch: {},
  async mounted () {
    this.national('mrbase_sys_client_param')
    if (this.$store.state.uuid) {
      await this.getDetail()
    }
    else {
    }
  },

  methods: {
    async getDetail () {
      this.skeletonloading = true
      const res = await staff_relation_detail({ uuid: this.$store.state.uuid })
      if (res.code == 200) {
        this.list = res.data
      } else {
      }
      this.skeletonloading = false
    },
    async success () {
      this.$v.list.$touch()
      if (this.$v.list.$error) return
      if (this.$store.state.uuid) {
        staff_relation_edit(this.$deletefield(null, this.list)).then(
          async (res) => {
            if (res.code == 200) {
              this.$Message({
                text: this.$t('message_The_operation_was_successful'),
              })
              await this.getDetail()
              this.$emit('changeReadonly')
            }
          }
        )
      }
      else {
        add_custom_param_config({
          ...this.list,
          // org_level_uuid: this.$store.state.currentCompany,
        }).then((res) => {
          if (res.code == 200) {
            this.$Message({ text: this.$t('message_added_successfully') })
            // this.$router.push({ name: 'staffRelation' })
          }
        })
      }
    },
    async cancel () {
      if (this.$store.state.uuid) {
        await this.getDetail()
        this.$emit('changeReadonly')
      }
      else {
        this.$myConfirm({
          content: this.$t('message_Confirm_the_cancellation_of_the_edit'),
        })
          .then((res) => {
            this.$router.push({
              name: 'staffRelation',
            })
          })
          .catch((err) => { })
      }

    },
  },
  validations: {
    list: {
      key: {
        required,
      },
      value: {
        required,
      },
      descrirption: {
        required,
      },
    },
  },
}
</script>

<style scoped></style>
